import AbstractContext from '@/shared/models/AbstractContext';
import { SurveySearchResult } from '../client/SurveyClient';
import SurveyFilters from './SurveyFilters';

export default class SurveyContext extends AbstractContext {
  constructor(
    readonly filters: SurveyFilters,
    readonly searchResult: SurveySearchResult,
  ) {
    super();
  }
}